import React from "react";

import { Amounts, Bet, Control, LimitMobile, Step } from "src/components/common";
import { PopupError } from "./components";
import { useMobile } from "./hooks";

import styles from "./style.module.scss";

export const Mobile = React.memo(() => {
  const { getAmountsProps, getPanelProps, getPopupErrorProps, getStepProps } =
    useMobile();
  return (
    <div {...getPanelProps()}>
      <div className={styles.panel}>
        <LimitMobile />
        <PopupError {...getPopupErrorProps()} />
        <div className={styles.controls}>
          <Control type="double" />
          <Control type="repeat" />
        </div>
        <Step {...getStepProps()} />
        <Bet secondary />
      </div>
      <Amounts {...getAmountsProps()} />
    </div>
  );
});

Mobile.displayName = "Mobile";
